module.exports = __webpack_public_path__ + "img/LogoDashboard-9.3d54b1ad.svg";